import { useEffect, useState } from 'react';
import { Grid, Pagination, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import Page from '../components/Controls/Page';
import ItemCard from '../components/ItemCard';
import { BaseAPI } from '../utils/Api';
import Notification from '../utils/Notification';
import { getItem, toTitleCase } from '../utils/Helper';
import LoadingState from '../components/Controls/LoadingState';

const Category = () => {
  const { name } = useParams();

  const [loading, setLoading] = useState(false);
  const [datasetList, setDatasetList] = useState([]);
  const [pageCount, setPageCount] = useState(null);

  useEffect(() => {
    getCategoryWiseDataset(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  const getCategoryWiseDataset = (pageCount) => {
    const getId = getItem(localStorage, 'un') || null;

    setLoading(true);
    const body = {
      category: name,
      page: pageCount,
    };

    BaseAPI.post(`/dataset/list?user_id=${getId}`, body)
      .then((res) => {
        setDatasetList(res.data.data.datasets);

        const totalPageCount = res.data.data.datasets.length / 12;
        setPageCount(Math.ceil(totalPageCount));
      })
      .catch((err) => {
        Notification(err?.response?.data?.message, 'error');
      })
      .finally(() => setLoading(false));
  };

  const handlePageChange = (_, value) => {
    getCategoryWiseDataset(value);
    setPageCount(value);
  };

  const handleWishList = (data) => {
    BaseAPI.post('/dataset/wishlist', { dataset_url: data }, { headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` } })
      .then((res) => {
        getCategoryWiseDataset(pageCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCart = (data) => {
    BaseAPI.post('/dataset/cartlist', { dataset_url: data }, { headers: { Authorization: `Bearer ${getItem(localStorage, 'at')}` } })
      .then((res) => {
        getCategoryWiseDataset(pageCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Page title={`${toTitleCase(name)}`}>
      <LoadingState loading={loading} />

      <Typography variant='h4' mt={2} mb={4} className='bold'>
        {toTitleCase(name)}
      </Typography>
      <Grid container spacing={2}>
        {datasetList?.map((el) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={el.url_name}>
            <ItemCard
              link={el.url_name}
              image={el.image}
              category={el.category}
              name={el.name}
              price={el.price}
              discount={el.discount}
              rows={el.data_rows}
              isCart={el.is_cart}
              isWish={el.is_wish}
              handleCart={handleCart}
              handleWishList={handleWishList}
            />
          </Grid>
        ))}
      </Grid>

      {pageCount && (
        <Grid container direction='row' justifyContent='center' alignItems='flex-end' my={4}>
          <Pagination count={pageCount} onChange={handlePageChange} />
        </Grid>
      )}
    </Page>
  );
};

export default Category;
